module.exports = __webpack_public_path__ + "img/banner1.d4ade846.png";